export default __webpack_public_path__ + "static/media/honor-product-01.56fa9f36.jpg";